/** 设置密码：至少 6 位，且同时包含字母与数字 */
export const PASSWORD_TIP = '至少6位，需同时包含字母和数字'

export function isValidPassword(pwd) {
  const s = String(pwd == null ? '' : pwd)
  return s.length >= 6 && s.length <= 32 && /[A-Za-z]/.test(s) && /\d/.test(s)
}

/** 不合法时返回错误文案，合法返回空串 */
export function passwordError(pwd, required = true) {
  const s = String(pwd == null ? '' : pwd).trim()
  if (!s) {
    return required ? '请设置密码' : ''
  }
  if (!isValidPassword(s)) {
    return PASSWORD_TIP
  }
  return ''
}
